import { css } from 'emotion';
import themeConfig from '@lyearn-team/theme-config';

const previewContainer = (loading, isMobile) => css`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  overflow: scroll;
  background-color: ${themeConfig.color.dark.uranus};
  .certificateWrapper {
    ${!isMobile &&
      css`
        transform: scale(0.7);
      `}
  }
  ${loading &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  .infoPopup {
    width: 100%;
    max-width: 800px;
    height: auto;
    min-height: 220px;
    position: relative;
    border-radius: 3px;
    ${isMobile &&
      css`
        main {
          padding: 30px 16px;
        }
        &.fullheight {
          height: 100%;
          margin: 0px;
        }
      `}
  }
`;

const certificateContainer = (isMobile, height) => css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: ${isMobile ? 'calc(100% - 200px)' : 'calc(100% - 250px)'};
  ${isMobile &&
    css`
      height: ${height}px;
      margin-top: 70px;
    `}
`;

const tabWrapperContainer = width => css`
  position: fixed;
  bottom: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .tabWrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-content: space-between;
    width: ${width}px;
    margin: auto;
  }
`;

const tab = () => css`
  padding-left: 10px;
  padding-right: 10px;
  .wrapper {
    display: flex;
    align-items: center;
  }
`;

const buttonText = () => css`
  padding-top: 5px;
  color: ${themeConfig.color.dark.white};
  text-transform: uppercase;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
`;

const copyButton = () => css`
  width: 100px;
  text-align: center;
  font-size: 12px;
  color: ${themeConfig.color.dark.white};
  text-transform: uppercase;
`;

const copyButtonSeperator = () => css`
  width: 1px;
  margin-top: -10px;
  height: 36px;
  border: solid 1px ${themeConfig.color.dark.mercury};
`;

const copyButtonWrapper = () => css`
  display: flex;
`;

const tabInnerWrapper = isMobile => css`
  margin: 0 auto;
  background: ${themeConfig.color.dark.saturn};
  padding: 15px 0px;
  .closeButton {
    position: absolute;
    right: 20px;
    top: 10px;
    ${isMobile &&
      css`
        right: 10px;
      `}
    .icon {
      width: 20px;
      height: 20px;
      fill: ${themeConfig.color.black3};
      ${isMobile &&
        css`
          fill: ${themeConfig.color.dark.white};
        `}
      :hover {
        fill: ${themeConfig.color.dark.white};
      }
    }
  }
  .goToLinkedIn {
    margin-top: 12px;
    margin-bottom: 10px;
    .icon {
      margin-left: 12px;
      width: 14px;
      height: 14px;
      fill: ${themeConfig.color.dark.white};
      ${isMobile &&
        css`
          margin-left: 0px;
          margin-right: 12px;
        `}
    }
    ${isMobile &&
      css`
        width: calc(100% - 32px);
        position: fixed;
        bottom: 15px;
      `}
  }
`;

const tabInnerHeader = isMobile => css`
  min-width: 166px;
  height: 29px;
  font-family: ChronicaPro;
  text-align: left;
  margin-bottom: 20px !important;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  ${isMobile &&
    css`
      font-family: PlayfairDisplay;
      line-height: 1.13;
      font-weight: 500;
    `}
`;

const tabInnerInstruction = () => css`
  margin-bottom: 32px !important;
  font-family: ChronicaPro;
  text-align: left;
`;

const darkLinkStyle = isMobile => css`
  display: flex;
  font-size: 12px;
  width: 100%;
  padding: 10px;
  justify-content: space-between;
  font-family: ChronicaPro;
  color: ${themeConfig.color.dark.white};
  height: 36px;
  border-radius: 3px;
  background-color: ${themeConfig.color.dark.mars};
  padding-right: 0px;
  ${isMobile &&
    css`
      .url {
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
    `}
`;

const tabInnerDetails = isMobile => css`
  ${!isMobile &&
    css`
      display: flex;
    `}
  margin-bottom: 20px;
`;

const tabInnerDetailsContent = (keyOrValue, isMobile) => css`
  min-width: 185px;
  height: 20px;
  font-family: ChronicaPro;
  text-align: left;
  color: ${themeConfig.color.black1};
  display: flex;
  align-items: center;
  ${isMobile &&
    css`
      width: 100%;
    `}
  color: ${themeConfig.color.dark.copper};
  ${keyOrValue === 'key' &&
    css`
      color: ${themeConfig.color.dark.iron};
    `}
    .certificateUrl {
      word-break: break-all!important;
      text-align: left !important;
      ${isMobile &&
        css`
          margin-top: 15px;
        `}
    }
    .copyIcon {
        cursor: pointer;
        width: 12px; 
        fill: ${themeConfig.color.dark.iron};
        :hover {
          fill : ${themeConfig.color.dark.white};
        }
      }
    .copyIconContainer {
      margin-left: 12px;
      > div {
        outline: none;
      }
    }
    .copyToClipboard {
      height: 28px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      background-color: ${themeConfig.color.black1};
      .text {
        font-family: ChronicaPro;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
      }
    }
`;

const certificateCloseButton = () => css`
  margin: 0px auto;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: -35px;
`;

const headerRoot = isMobile => css`
  background: ${themeConfig.color.dark.uranus};
  display: flex;
  width: 100vw;
  height: ${isMobile ? '56px' : '74px'};
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  z-index: 1002;
  ${isMobile &&
    css`
      border-bottom: 1px solid ${themeConfig.color.dark.mars};
      padding: 0 10px;
    `}
`;

const certificateInfo = isMobile => css`
  width: 100%;
  text-align: center;
  margin-top: 14px;
  ${isMobile &&
    css`
      text-align: left;
      padding: 0 20px;
    `}
  .completion {
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    font-family: ChronicaPro;
  }
  .congratulations {
    font-family: PlayfairDisplay;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
  }
  .contentInfo {
    font-family: ChronicaPro;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    margin-top: 4px;
    .contentName {
      color: ${themeConfig.color.dark.silver};
      font-weight: 500;
    }
  }
`;

const shareButton = css`
  font-size: 12px !important;
  font-weight: 500 !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5 !important;
  letter-spacing: 0.5px !important;
  color: ${themeConfig.color.dark.white} !important;
  width: calc(100% - 30px);
  position: fixed !important;
  bottom: 25px;
  margin: 0 15px;
`;

const animateSlider = css`
  height: auto !important;
  .optionsWrapper {
    width: 100%;
    height: 100%;
    background-color: ${themeConfig.color.dark.saturn};
    font-family: ChronicaPro;
    padding-bottom: 20px;
    .header {
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      border-bottom: 1px solid ${themeConfig.color.dark.mars};
      height: 50px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 0 20px;
    }
    .option {
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      display: flex;
      align-items: center;
      padding: 0 14px;
      :not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
`;

export default {
  previewContainer,
  certificateContainer,
  tabInnerDetailsContent,
  buttonText,
  copyButton,
  copyButtonSeperator,
  copyButtonWrapper,
  tab,
  darkLinkStyle,
  tabInnerInstruction,
  tabInnerHeader,
  tabInnerWrapper,
  tabWrapperContainer,
  tabInnerDetails,
  certificateCloseButton,
  headerRoot,
  certificateInfo,
  shareButton,
  animateSlider
};
